import { UUID } from "@bitory-gmbh/nidavellir";

/** Mirrors `offer.DefaultBaseDataKey`, backend/core/omni/domain/offer/base_data.go. */
export function omniOfferBaseDataKey(serviceKind: string): string {
  return `omni.offer.baseData.${serviceKind}`;
}

/** Mirrors `offer.BaseData`, backend/core/omni/domain/offer/base_data.go. */
export type OfferBaseData = {
  id: UUID;
  companyId: UUID;
  label: string;
  createdAt: string;
  updatedAt: string;
  serviceKind: string;
  title: string;
  subtitle: string;
  text: string;
};

/** Mirrors `offer.BaseDataPatch`, backend/core/omni/domain/offer/base_data.go. */
export type OfferBaseDataPatch = {
  label?: string;
  title?: string;
  subtitle?: string;
  text?: string;
};

export function patchOfferBaseData(
  baseData: OfferBaseData,
  patch: OfferBaseDataPatch,
): OfferBaseData {
  return { ...baseData, ...patch };
}
